import { WorkflowConstants } from "lookup/WorkflowConstants";

export const buildSwitchDispositionPayload = (formValues, rawDetails) => ({
  disposition: formValues.disposition,
  selectedTargets: formValues.targets,
  rejectionReason: formValues.rejectionReason,
  futureSwitchTreatment: formValues.futureSwitchTreatment,
  note: {
    note:
      rawDetails.wfItemStatus === WorkflowConstants.DELIVERED_PRESCRIBER_FAX
        ? `${formValues.disposition} - over the phone  -- ${formValues.notes}`
        : formValues.notes,
  },
  pushToPharmacy: false,
});

export const validateSwitchDisposition = (
  formValues,
  selectableDispositions,
  rawDetails
) => {
  const targetOptions = rawDetails.targetOptions?.[0];
  const items = targetOptions?.dynamicSwitchItems || [];

  if (formValues.disposition === "") {
    return "Please select disposition.";
  }

  if (formValues.disposition === selectableDispositions.ACCEPTED) {
    if (items.length > 1 && formValues.targets.length === 0) {
      return "Please check atleast one target option.";
    }
    return null;
  }

  if (formValues.disposition === selectableDispositions.SUBMITTED_VIA_EHR) {
    return null;
  }

  if (formValues.disposition === selectableDispositions.THERAPY_DISCONTINUED) {
    return null;
  }

  if (formValues.disposition === selectableDispositions.MEMBER_ON_TARGET) {
    return null;
  }

  if (formValues.disposition === selectableDispositions.DECLINED) {
    if (formValues.rejectionReason === "") {
      return "Please select rejection reason.";
    }
    if (formValues.futureSwitchTreatment === "") {
      return "Please select future switch treatment.";
    }
  }

  return null;
};

export const buildDmrDispositionPayload = (formValues) => ({
  dmrOptions: formValues.dmrOptions,
  note: {
    note: formValues.notes,
  },
});

export const validateDmrDisposition = (formValues) => {
  if (!formValues.dmrOptions?.length) {
    return "Please select at least one disposition option.";
  }
  return null;
};

export const buildDispositionPayload = (
  faxProgramCode,
  formValues,
  rawDetails
) => {
  if (faxProgramCode === "DMR") {
    return buildDmrDispositionPayload(formValues);
  }

  return {
    disposition: buildSwitchDispositionPayload(formValues, rawDetails),
  };
};

export const validateDisposition = (
  faxProgramCode,
  formValues,
  selectableDispositions,
  rawDetails
) => {
  if (faxProgramCode === "DMR") {
    return validateDmrDisposition(formValues);
  }

  return validateSwitchDisposition(
    formValues,
    selectableDispositions,
    rawDetails
  );
};

export const getSelectableDispositions = (
  rawDetails,
  selectableDispositions,
  {
    changeDisposition,
    isForAccepted,
    isForDeclined,
    isPrescriberResponseFaxAvailable,
  }
) => {
  const nextDispositions = { ...selectableDispositions };

  if (
    rawDetails.wfItemStatus === WorkflowConstants.DELIVERED_PRESCRIBER_FAX ||
    rawDetails.wfItemStatus ===
      WorkflowConstants.MISSING_PRESCRIBER_CONTACT_INFO
  ) {
    delete nextDispositions.ACCEPTED;
  }

  if (isForAccepted) {
    delete nextDispositions.SUBMITTED_VIA_EHR;
    delete nextDispositions.MEMBER_ON_TARGET;
    delete nextDispositions.THERAPY_DISCONTINUED;
  }

  if (isForDeclined) {
    delete nextDispositions.DECLINED;
  }

  if (changeDisposition && !isPrescriberResponseFaxAvailable) {
    delete nextDispositions.ACCEPTED;
  }

  return nextDispositions;
};
